export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16">條件單風險聲明</div>

    <div class="doc-text doc-pt16 doc-pb28">1. 條件單允許客戶，可以預先設定某股票的觸發條件。在有效日期之前，當股票價格觸及預先設定的條件時（以下簡稱為觸發），系統將會自動將客戶預先設定的買賣指令，發送給交易所。條件單有效期內，觸發條件只會被觸發一次。觸發系統送出預先設定的買賣指令，或期限到期時，條件單失效。任何時候，客戶可以隨時取消條件單或更改條件單內觸發條件。條件單能有效協助客戶，在市場出現大幅波動時，快速把握機會，或將風險及損失減至最低。</div>

    <div class="doc-text doc-pb16">2. 條件單的觸發要素主要包括「價格」及「時間」兩種，兩項條件可以同時設定，當客戶下條件單時，必須同時輸入觸發後的指令，即以下信息：</div>
    <div class="doc-li doc-pb16">觸發條件（即觸發價格及／或時間）</div>
    <div class="doc-li doc-pb16">買賣方向 (即買出或賣出)</div>
    <div class="doc-li doc-pb16">股票代碼</div>
    <div class="doc-li doc-pb16">委託數量</div>
    <div class="doc-li doc-pb16">委託價格</div>
    <div class="doc-text doc-pb28">當條件單對應的股票最新價格到達至上述的設定價格條件時，或時間達到設定時間條件時，視為觸發。</div>

    <div class="doc-text doc-pb28">3. 觸發時，系統將會自動將預先設定的客戶指令，送至交易所內執行。假如買賣指令並未能於當天成功執行，該買賣指令會於當天收市後自動取消。當預先設定的條件單仍然在有效期內，且未發生觸發時，預先設定的買賣指令將不會被送至交易所內執行，該條件單會繼續保留在賬戶內，直至有效期終止或客戶取消條件單。</div>

    <div class="doc-text doc-pb28">4. 客戶須通過網上交易平台或APP下條件單。假如客戶想更改條件單內的觸發條件或取消條件單，亦需要通過網上交易平台或APP自行處理。條件單一經觸發，客戶預先設定的買賣指令即被送至交易所，該買賣指令為有效指令，客戶作為指令發出人，需自行承擔所有與指令有關的責任。盈寶證券國際(香港)有限公司 (“盈寶證券”)均不會因任何損失利潤或損失機會、或任何間接、特別、隨之發生的、偶發性、懲罰性損害或賠償而對客戶承擔任何責任。</div>

    <div class="doc-text doc-pb28">5. 當股票價格觸及客戶預先設定的觸發條件時，條件單將有機會因客戶當時賬戶內的持倉、資金、購買力及/或融資額度等，皆未能符合要求，而令系統無法將預先設定的買賣指令，送至交易所內執行。盈寶證券一概不會負責或保證客戶預先設定的買賣指令，一定可以被送到交易所內執行。因此，在設定條件單前，客戶應詳細了解股票價格，也應詳細了解，賬戶內的持倉、資金、購買力及/或融資額度是否已符合要求，避免觸發後，因未能符合要求而無法將買賣指令送到交易所內執行。</div>

    <div class="doc-text doc-pb28">6. 當設定條件單時，客戶同時須要注意設定的委託價，可能因不同種類的買賣盤機製或距離市場實時價位的限制等因素，出現買賣指令無法送到交易所內執行。所以，客戶設定條件單前，應先了解市場實時的狀況及股票的波動。因條件單使用方法較一般買賣指令複雜，建議客戶先清楚了解條件單的功能和運作後，才決定應否設定條件單及如何設定條件單。</div>

    <div class="doc-text doc-pb28">7. 互聯網是一個不完全穩定或絕對安全的數據傳輸及通訊媒體。由於互聯網或流動電話網絡傳輸速率或出現不穩定的原因，客戶在獲取股票信息時，有可能會出現滯後、延誤或誤差的情況。客戶在處理網上交易平台或流動電話APP下條件單時，網絡系統可能會出現中斷、停頓、延遲、數據誤差或不完整等情況，或計算器出現故障及互聯網數據傳輸緩慢等原因，交易信號或指令可能會出現中斷、停頓、延遲、數據誤差或不完整等情況，由此等問題所產生的任何損失，盈寶證券皆不會承擔任何責任。</div>

    <div class="doc-text doc-pb28">8. 如果因為互聯網或流動電話網絡之通訊系統，出現故障、過於頻繁、機房或服務器遭到破壞或負載過重，或受到網絡黑客、病毒的攻擊、入侵等原因，導致買賣交易出現延遲、停頓、中斷、誤差或系統接收出現錯誤信息，令條件單不能觸發全部或部分的條件，由此產生的直接或間接的損失，盈寶證券皆不會承擔任何責任。</div>

    <div class="doc-text doc-pb28">9. 條件單是依據基本的市場規則和運作而製定。因此，客戶在設定條件單前，應先清楚了解條件單內的功能、特性、操作重點和相關風險。客戶須自行承擔設定條件單後所有風險及令客戶造成的直接或間接損失。包括，但不限於，不了解執行邏輯、大量買入股數的控制變量，或個人操作失誤。客戶須知悉設定條件單時，有可能存在出現誤差，並可以導致客戶預先設定的買賣指令出現誤差、無效或失誤。客戶應謹慎操作，避免承擔損失。</div>

    <div class="doc-text doc-pb28">10. 由於電子化交易的特點，因此，客戶要清楚知道，使用條件單成功執行的買賣指令，有時候，可能會出現與客戶預先設定的買賣指令並不一致。但最後成交結果，皆以交易所的交易結果為準。客戶須自行承擔後果和責任。</div>

    <div class="doc-text doc-pb28">11. 在使用條件單的過程中，可能因係統故障、網絡問題或因預計技術未能克服等原因，導致條件單功能可能會出現誤差或延遲，包括但不限於條件單未準確觸發、誤觸發、到價未觸發和到期限未觸發等情況。盈寶證券不能夠保證，條件單功能符合或達到客戶的要求。亦不可以對盈寶證券網絡服務及相關功能作出任何承諾。同時，也不會就上述服務的及時性、安全性、準確性而作出任何承諾。客戶在設定條件單之前，應明確清楚，要為自己所設定的條件單承擔所有風險和責任。</div>

    <div class="doc-text doc-pb28">12. 盈寶證券會不定時對相關設備、網絡或服務器進行檢查或維修，以使網絡的運作更快捷及更暢順。從而造成在設定條件單的功能時，稍有延誤。盈寶證券將盡力控制延誤在最短時間內。但在該期間內的服務出現延誤或中斷，盈寶證券不會承擔任何責任及損失。</div>

    <div class="doc-text doc-pb16">注意事項</div>

    <div class="doc-li doc-pb16">條件單適用於港股市場及美股市場。</div>
    <div class="doc-li doc-pb16">支持港股的增強限價單，美股的限價單及市價單。</div>
    <div class="doc-li doc-pb16">對於港股市場，條件單在連續競價交易時段（9:30-12:00、13:00-16:00）才會被觸發，開市前集合競價交易時段（9:00-9:20）及收市集合競價交易時段（16:01-16:10）並不適用。</div>
    <div class="doc-li doc-pb16">對於美股市場，條件單在所有交易時段內均可觸發，包括盤前盤後，選擇允許盤前盤後，則條件單會在盤前、盤中、盤後全時段監控並觸發，提交的委託單也是允許盤前盤後的，不允許盤前盤後則同理。</div>
    <div class="doc-li doc-pb16">下條件單時，暫不判斷其可買、可賣數量是否足夠，而是當條件觸發時再判斷。</div>
    <div class="doc-li doc-pb28">可以設置有效時間。</div>
  </div>
`
